<template>
  <div>
    <div class="hidden"><AppHeader /></div>
    <UMain class="min-h-[100dvh]">
      <slot />
    </UMain>
  </div>
</template>
